
// @utilities
const Storage = require('utilities/storage');

// @constants
const {
    DEBUG_STRINGS,
    DEBUG_FLAG_ON,
    DEBUG_FLAG_OFF
} = require('constants/debug');


const showPoeditorStrings = () => Storage.localStorage.set(DEBUG_STRINGS, 'true');

const hidePoeditorStrings = () => Storage.localStorage.remove(DEBUG_STRINGS);

const showKeys = isProduction => !isProduction && !!Storage.localStorage && !!Storage.localStorage.get(DEBUG_STRINGS);

const checkDebugFlags = (params) => {
    if (params.get('debug')) {
        let debugFlag = params.get('debug').toUpperCase();
        if (debugFlag === DEBUG_FLAG_ON){
            Storage.localStorage.set('debugMode', 'true');
        } else if (debugFlag === DEBUG_FLAG_OFF){
            Storage.localStorage.remove('debugMode');
        }
    }

    if (params.get('mostrar-cadenas')) {
        showPoeditorStrings();
    }

    if (params.get('ocultar-cadenas')) {
        hidePoeditorStrings();
    }
}

module.exports = {
    showPoeditorStrings,
    hidePoeditorStrings,
    showKeys,
    checkDebugFlags,
};
